import { coresFigma } from '../../styles/colors';

const useIndicatorChart = ({ indicatorValue, goalValue, goalMessage }) => {
    const minBarWidth = 0.5;

    const adjustedIndicatorValue =
        indicatorValue < minBarWidth ? minBarWidth : indicatorValue;
    const adjustedGoalValue = goalValue < minBarWidth ? minBarWidth : goalValue;

    const chartConfig = {
        series: goalValue
            ? [adjustedIndicatorValue || 0, adjustedGoalValue]
            : [adjustedIndicatorValue || 0],
        options: {
            chart: {
                type: 'radialBar',
                offsetY: 0,
                toolbar: {
                    show: true
                }
            },
            plotOptions: {
                radialBar: {
                    track: {
                        strokeWidth: '100%',
                        margin: 5,
                        minStrokeWidth: 2
                    },
                    hollow: {
                        size: '55%'
                    },
                    dataLabels: {
                        showOn: 'always',
                        name: {
                            show: false,
                            formatter: () => '', 
                            offsetY: 0
                        },
                        value: {
                            show: true,
                            fontSize: '18px',
                            fontWeight: 'bold',
                            offsetY: 5,
                            formatter: function (val, { seriesIndex }) {
                                const realValue =
                                    val === adjustedIndicatorValue
                                        ? indicatorValue
                                        : goalValue;
                                return `${Number(realValue).toFixed(2)}%`;
                            }
                        },
                        total: {
                            show: true,
                            fontSize: '18px',
                            fontWeight: 'bold',
                            formatter: function () {
                                return `${Number(indicatorValue).toFixed(2)}%`;
                            },
                            offsetY: 0
                        }
                    }
                }
            },
            fill: {
                type: 'solid',
                colors: goalValue
                    ? [coresFigma.neutras.cinzaEscuro, coresFigma.neutras.preto]
                    : [coresFigma.neutras.cinzaEscuro]
            },
            labels: goalValue
                ? ['Valor Atual', goalMessage || 'Meta']
                : ['Valor Atual'],
            stroke: {
                colors: goalValue
                    ? [coresFigma.neutras.cinzaEscuro, coresFigma.neutras.preto]
                    : [coresFigma.neutras.cinzaEscuro]
            },
            tooltip: {
                enabled: true,
                fillSeriesColor: false,
                style: {
                    fontSize: '12px',
                    fontFamily: undefined
                },
                theme: 'light',
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    const label = w.globals.labels[seriesIndex];
                    const value = Number(series[seriesIndex]).toFixed(2);
                    const color =
                        seriesIndex === 0
                            ? coresFigma.neutras.cinzaEscuro
                            : coresFigma.neutras.preto;

                    return `
                   <div style="
                        background: white;
                        padding: 6px 10px;  // Padding reduzido
                        border-radius: 4px;  // Bordas menos arredondadas
                        box-shadow: 0 2px 8px rgba(0,0,0,0.1);  // Sombra mais suave
                        border-left: 3px solid ${color};  // Borda lateral fina
                        color: #444;
                    ">
                        <div style="
                            font-weight: 500;  // Peso médio para o label
                            font-size: 11px;  // Tamanho reduzido
                            margin-bottom: 2px;  // Espaçamento mínimo
                            color: ${color};
                        ">
                            ${label}
                        </div>
                        <div style="
                            font-size: 14px;  // Valor um pouco maior (mas não exagerado)
                            font-weight: 600;  // Semibold para o valor
                        ">
                            ${value}%
                        </div>
                    </div>`;
                },
                cssClass: 'custom-tooltip-class',
                marker: {
                    show: true,
                    fillColors: [
                        coresFigma.neutras.cinzaEscuro,
                        coresFigma.neutras.preto
                    ]
                },
                y: {
                    formatter: function (val, { seriesIndex }) {
                        const realValue =
                            seriesIndex === 0 ? indicatorValue : goalValue;
                        return `${Number(realValue).toFixed(2)}%`;
                    }
                }
            }
        }
    };

    return {
        chartConfig
    };
};

export default useIndicatorChart;
